import { Component } from '@angular/core';

@Component({
  selector: 'extra-layout',
  templateUrl: 'extra.container.html',
  styleUrls: ['extra.container.scss'],
})
export class ExtraLayoutContainerComponent {
  rtl: boolean;

  constructor( ) {
    this.rtl = false;
  }
}
